import * as Yup from "yup";

export const TenantSchema = Yup.object().shape({
  name: Yup.string().min(3, "The name is too short").max(25, "The name is too long").required("Please enter the business name"),
  category: Yup.string().required("Please select a category"),
  tenantcode: Yup.string().required()
});